import script from "./HrCircularProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./HrCircularProgress.vue?vue&type=script&setup=true&lang=js"

import "./HrCircularProgress.vue?vue&type=style&index=0&id=07e50a70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e50a70"]])

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress});
